<header class="header">
  <div class="logo-red" routerLink="/login"></div>
</header>

<form class="lang-form" [formGroup]="form">
  <div class="lang-box">
    <p-selectButton name="language" 
      formControlName="language" 
      [options]="languageOptions" 
      optionLabel="name"
      optionDisabled="disabled" 
      (click)="fixLanguage()">
      <ng-template let-item pTemplate>
        <div [class]="item.class"></div>
      </ng-template>
    </p-selectButton>
  </div>
</form>

<div class="login-wrapper" [style.display]="isNotDivPass">
  <div class="login-card" >
    <div class="divEmail" [style.display]="isDivEmail">
      <div class="title" >
        <h2>{{ "user.forgotPassword.header" | transloco }}</h2>
      </div>
      <form class="form" [formGroup]="form">
      <label for="email">{{ "user.forgotPassword.title" | transloco }}</label>
      <input
        type="email"
        id="email"
        formControlName="email"
        placeholder="{{ 'user.forgotPassword.enterEmail' | transloco }}"
        pInputText
      />
      <p-button
          id="btnSend"
          (click)="onSubmit()"
          [loading]="submitBtnLoading"
          severity="danger"
          [raised]="true"
          label="{{ 'user.forgotPassword.btnSend' | transloco }}"
        >
        </p-button>
        <div class="button-wrapper" (click)="backLogin()">
          <div class="button-inner">
            <p-button id="btnBack" name="btnBack" [label]="'common.buttons.back' | transloco"  [raised]="true"
              styleClass="custom-button"></p-button>
          </div>
        </div>

      <!-- <button
        pButton
        type="button"
        label="Voltar"
        class="btn-outline"
        (click)="backLogin()"
      ></button> -->
      </form>
    </div>

    <div class="divCode" [style.display]="isDivCode">
      <div class="title">
        <h2>{{"user.forgotPassword.header2" | transloco }}</h2>
        <p>{{ "user.forgotPassword.title2" | transloco }}</p>
        <h3>{{ email }}</h3>
      </div>
      <form class="form" [formGroup]="formCode">
        <!-- <p-inputOtp formControlName="code" [integerOnly]="true" [length]="6" /> -->
            <p>{{ "user.forgotPassword.linkMsg" | transloco }}</p>
            <div class="row">
        {{ "user.forgotPassword.resend" | transloco }}
        <a
          [routerLink]="[]"
          (click)="sendEmailAgain()"
          [class.disabled]="isButtonDisabled"
          [attr.aria-disabled]="isButtonDisabled ? 'true' : null"
          [style.pointer-events]="isButtonDisabled ? 'none' : 'auto'"
        >
          {{ "user.forgotPassword.resend2" | transloco }}
        </a>
        <span *ngIf="isButtonDisabled">({{ countdown }}s)</span>
      </div>
      </form>
      
      
      <div class="button-wrapper" (click)="backLogin()">
          <div class="button-inner">
            <p-button id="btnBack" name="btnBack" [label]="'common.buttons.back' | transloco" [raised]="true" styleClass="custom-button"></p-button>
          </div>
        </div>
    </div>
  </div>
</div>

<div class="login-wrapper" [style.display]="isDivPass">
  <div class="login-card-newPass">
    <div class="divPass">
      <div class="title">
        <h2>{{"user.forgotPassword.header2" | transloco }}</h2>
        <p>{{ "user.forgotPassword.title3" | transloco }}</p>
        <h3>{{ email }}</h3>
      </div>
      <form class="form" [formGroup]="formPass">
      <p-password
        id="password"
        class="ig-pass"
        formControlName="password"
        name="password"
        placeholder="{{ 'user.forgotPassword.newPass' | transloco }}*"
        promptLabel="{{ 'user.createAccount.passwordInput' | transloco }}"
        weakLabel="{{ 'user.createAccount.passwordShort' | transloco }}"
        mediumLabel="{{ 'user.createAccount.passwordMedium' | transloco }}"
        strongLabel="{{ 'user.createAccount.passwordLong' | transloco }}"
        [toggleMask]="true"
        [style]="{ width: '100%' }"
        [inputStyle]="{ width: '100%' }"
       
      />
      <app-password-strength-checklist
        [password]="formPass.get('password')?.value">
      </app-password-strength-checklist>
      <small id="password-help" style="margin-top: 5px">
        {{ "user.createAccount.passwordText" | transloco }}
      </small>
      <p-password
        id="passwordConfirm"
        class="ig-pass"
        formControlName="passwordConfirm"
        name="passwordConfirm"
        placeholder="{{ 'user.forgotPassword.confirmPass' | transloco }}*"
        [toggleMask]="true"
        [style]="{ width: '100%' }"
        [inputStyle]="{ width: '100%' }"
      />
      
      </form>
        <p-button
          id="btnSend"
          (click)="onSubmitPass()"
          [loading]="submitBtnLoading"
          severity="danger"
          [raised]="true"
          label="{{ 'user.forgotPassword.btnSend' | transloco }}"
        >
        </p-button>
      <div class="button-wrapper" (click)="backLogin()">
          <div class="button-inner">
            <p-button id="btnBack" name="btnBack" [label]="'common.buttons.back' | transloco" [raised]="true" styleClass="custom-button"></p-button>
          </div>
        </div>
    </div>    
  </div>
  <!-- <p-messages
        id="messages"
        [(value)]="messagesPass"
        [enableService]="false"
        [style]="{ 'font-size': '15px' }"
      /> -->
</div>

<p-toast key="toastMessages" />

<footer class="footer" [ngStyle]="{'background-image': footerBackground}">
  <div class="footer-content">
    <!-- <div class="footer-top">
      <select class="language-select">
        <option value="pt-BR">🇧🇷 Brasil - Português</option>
      </select>
    </div> -->
    <div class="footer-logo">
      <img src="assets/img/logo-FTCloud-white.svg" alt="FT Pilot" />
    </div>
    <div class="footer-bottom">
      <p>{{'footer.rightsReserved' | transloco }}</p>
    </div>
  </div>
</footer>